let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bQxQQ")).then(() => parcelRequire('avO0W'));